/**
 *
 * @param {字段中文含义} str
 * 非空，单独空格视为空
 */
export const NotEmpty = str => {
  return {
    required: true,
    message: `请输入${str}`,
    trigger: 'blur',
    whitespace: true
  }
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
  return reg.test(email)
}

/**
 * 中国大陆手机号校验：以1开头，第二位3-9，后续9位数字
 * @param {string} phone
 * @returns {Boolean}
 */
export function validPhone(phone) {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(String(phone))
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

// type 1：只能输入中英文、"."和"·"
// type 2:如果输入的是小数，就保留两位小数 否则就输入什么展示什么
// type 3:只能输入正整数
// type 4:只能输入英文和数字
export function inputRule(value, type) {
  if (type === 1) {
    return value.replace(/[^\u4e00-\u9fa5.·a-zA-Z]/g, '')
  }
  //保留两位小数
  if (type === 2) {
    const y = String(value).indexOf('.') + 1 //获取小数点的位置
    //判断是不是小数，如果是小数就保留两位小数
    if (y > 0) {
      //说明是小数
      // String(parseFloat(value).toFixed(2))
      return Number(parseFloat(value).toFixed(2))
    } else {
      return Number(value)
    }
  }
  if (type === 3) {
    return value.replace(/[^0-9]/g, '')
  }
  if (type === 4) {
    return value.replace(/[^0-9a-zA-Z]/g, '')
  }
  if (type === 5) {
    return value.replace(/[^0-9、]/g, '')
  }
}

/**
 * 校验排除白名单外的对象keys长度
 * @param {*} exclude 白名单
 * @param {*} func 当前校验的Object
 * @returns 排除白名单外的对象keys长度
 */
export function queryValidate(exclude, func) {
  const whiteList = [...exclude]
  const queryValue = []
  Object.keys(func).forEach(item => {
    if (!whiteList.includes(item) && (func[item] || func[item] === 0)) {
      queryValue.push(item)
    }
  })
  return queryValue.length >= 1
}
